<style lang="less">
    .modifyBlock-modal {
        width: 200px;
        height: 300px;
        .modifyBlock-radioGroup {
            padding: 0 20px;
        }
    }
</style>

<style lang="stylus">
    .modifyBlock-mask
        .dialog-btnbox-normal
            border none
</style>

<template>
    <div class="modifyBlock-mask">
        <Dialog class="modifyBlock-modal" :title="$t('ModifyBlock.title')" :isShow="true" :mask="true" @close="closeModal">
            <RadioGroup v-model="type" vertical class="modifyBlock-radioGroup">
                <Radio v-for="item in typeList" :key="item.id" :label="item.type">
                    <span>{{ $t(item.text) }}</span>
                </Radio>
            </RadioGroup>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="modify()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    @Component({
        components: {
            Dialog,
        },
    })
    export default class modifyBlock extends Vue {
        type: number = 0;
        typeList: Array<Object> = [];

        modify() {
            let view = window["_view"];
            if (view) {
                view.modifyRow(this.type, this.segPosition[0], this.segPosition[1]);
                view.getActiveData();
            }
            this.closeModal();
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        initData() {
            this.typeList = [
                {
                    id: 0,
                    type: this.ModifyType.MoveTo,
                    text: "ModifyBlock.MoveTo",
                },
                {
                    id: 1,
                    type: this.ModifyType.LineTo,
                    text: "ModifyBlock.LineTo",
                },
                {
                    id: 2,
                    type: this.ModifyType.CurveTo,
                    text: "ModifyBlock.CurveTo",
                },
                {
                    id: 3,
                    type: this.ModifyType.ArcTo,
                    text: "ModifyBlock.ArcTo",
                },
                {
                    id: 4,
                    type: this.ModifyType.EllipArc,
                    text: "ModifyBlock.EllipArcTo",
                },
                {
                    id: 5,
                    type: this.ModifyType.Ellipse,
                    text: "ModifyBlock.Ellipse",
                },
                {
                    id: 6,
                    type: this.ModifyType.ArcTo2,
                    text: "ModifyBlock.ArcTo2",
                },
            ];
        }

        get segPosition() {
            return this.$store.state.ui.segPosition;
        }
        get ModifyType() {
            return this.$store.state.datasheet.ModifyType;
        }

        mounted() {
            this.type = 0;
        }

        created() {
            this.initData();
        }
    }
</script>
<i18n>
{
  "zh": {
    "ModifyBlock": {
      "title": "修改块",
      "MoveTo": "移动到",
      "LineTo": "终点",
      "CurveTo": "曲线",
      "ArcTo": "弧线",
      "EllipArcTo": "椭圆弧",
      "Ellipse": "椭圆形",
      "ArcTo2": "弧线2"
    },
    "confirm": "确定",
    "cancel": "取消"
  },
  "fr": {
    "ModifyBlock": {
      "title": "Modifier le Bloc",
      "MoveTo": "Déplacer vers",
      "LineTo": "Ligne vers",
      "CurveTo": "Courbe",
      "ArcTo": "Arc",
      "EllipArcTo": "Arc Elliptique",
      "Ellipse": "Ovale",
      "ArcTo2": "Arc 2"
    },
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "ModifyBlock": {
      "title": "Block modifizieren",
      "MoveTo": "Ziehen nach",
      "LineTo": "Endpunkt",
      "CurveTo": "Kurve ",
      "ArcTo": "Arc",
      "EllipArcTo": "Eliptischer Bogen nach",
      "Ellipse": "Elipse",
      "ArcTo2": "Arc2"
    },
    "confirm": "Sichern ",
    "cancel": "Abbrechen"
  },
  "en": {
    "ModifyBlock": {
      "title": "Modify Block",
      "MoveTo": "Move To",
      "LineTo": "Line To",
      "CurveTo": "Curve To",
      "ArcTo": "Arc To",
      "EllipArcTo": "Ellipical Arc To",
      "Ellipse": "Ellipse",
      "ArcTo2": "Arc To 2"
    },
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "jp": {
    "ModifyBlock": {
      "title": "ブロックを編集",
      "MoveTo": "移動",
      "LineTo": "終点",
      "CurveTo": "曲線",
      "ArcTo": "弧線1",
      "EllipArcTo": "楕円弧",
      "Ellipse": "楕円",
      "ArcTo2": "弧線2"
    },
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "es": {
    "ModifyBlock": {
      "title": "Modificar Bloqueo",
      "MoveTo": "Mover a ",
      "LineTo": "Linea a",
      "CurveTo": "Curva a",
      "ArcTo": "Arco a",
      "EllipArcTo": "Arco elíptico a",
      "Ellipse": "Elipse",
      "ArcTo2": "ArcTo2"
    },
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "ModifyBlock": {
      "title": "Modificar Bloco",
      "MoveTo": "Mover Para",
      "LineTo": "Linha Para",
      "CurveTo": "Curva Para",
      "ArcTo": "Arco Para",
      "EllipArcTo": "Arco Elíptico Para",
      "Ellipse": "Elipse",
      "ArcTo2": "Arco Para 2"
    },
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "ModifyBlock": {
      "title": "Modifica Blocco",
      "MoveTo": "Sposta",
      "LineTo": "Linea",
      "CurveTo": "Curva",
      "ArcTo": "Arco",
      "EllipArcTo": "Arco Ellittico",
      "Ellipse": "Ellisse",
      "ArcTo2": "Arco 2"
    },
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "ModifyBlock": {
      "title": "修改塊",
      "MoveTo": "移動到",
      "LineTo": "終點",
      "CurveTo": "曲線",
      "ArcTo": "弧線",
      "EllipArcTo": "橢圓弧",
      "Ellipse": "橢圓形",
      "ArcTo2": "弧線2"
    },
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "ModifyBlock": {
      "title": "블록 수정",
      "MoveTo": "다음으로 이동",
      "LineTo": "종착점",
      "CurveTo": "곡선",
      "ArcTo": "호선",
      "EllipArcTo": "타원호",
      "Ellipse": "타원형",
      "ArcTo2": "호선2"
    },
    "confirm": "확인",
    "cancel": "취소"
  }
}
</i18n>
